function checkMenuExtended(path = "") {
  const subPaths = [
    "/dashboard",
    "/admin/users",
    "/admin/reports",
    "/admin/exercise-library",
    "/admin/tutorials",
  ];

  const reducer = (acc = false, curr) => acc || path.indexOf(curr) !== -1;

  return !(
    ["/dashboard/calendar", "/dashboard/calendar/"].includes(path) ||
    subPaths.reduce(reducer, false)
  );
}

export default checkMenuExtended;
